import actionTypes, { getDataset } from "./_actions";
import { createFarm, fetchFarm } from "../Farm/_actions";
import { createBudget, fetchBudget } from "../Budget/_actions";
import { v4 as uuidv4 } from "uuid";
import * as utils from "common/utils";
import { combineEpics } from "redux-observable";

const createDatasetBudget = (store, payload) => {
    const { analysis, farmId } = payload;
    const storeState = store.value;
    const { offlineFarms = [] } = storeState;
    const originalFarm = offlineFarms.find((f) => f.id === analysis.farmId) || { farm: {} };
    const { farm = {} } = originalFarm;
    const { offlineBudgets = [] } = farm;
    const offlineBudget = offlineBudgets.find((b) => b.id === analysis.id) || {};
    const { budget } = offlineBudget;
    const newBudget = utils.clone(budget);
    newBudget.id = uuidv4();
    newBudget.farmId = farmId;
    newBudget.name = utils.truncateText(farm.name, 40) + " - copy";
    return createBudget(newBudget, true, false, false, [{ type: actionTypes.DATASET_BUDGET_FETCH_DATASET, payload: newBudget.datasetId }]);
};

const createDatasetFarm = (store, budget) => {
    const storeState = store.value;
    const { offlineFarms = [] } = storeState;
    const originalFarm = offlineFarms.find((f) => f.id === budget.farmId) || { farm: {} };
    const { farm = {} } = originalFarm;
    const newFarm = utils.clone(farm);
    delete newFarm.offlineBudgets;
    newFarm.name = `${utils.truncateText(farm.name, 40)} - copy`;
    newFarm.id = uuidv4();
    newFarm.isNew = true;
    newFarm.budgets = [];
    return createFarm(newFarm, true, [{ type: actionTypes.DATASET_BUDGET_COPY_BUDGET, payload: { analysis: budget, farmId: newFarm.id } }]);
};

const initBudgetCopyEpic = (action$) => action$.ofType(actionTypes.DATASET_BUDGET_COPY).map((rsp) => ({ type: actionTypes.DATASET_BUDGET_FETCH_FARM, payload: rsp.payload }));

const fetchFarmEpic = (action$) => action$.ofType(actionTypes.DATASET_BUDGET_FETCH_FARM).map((rsp) => fetchFarm(rsp.payload.farmId, true, false, [{ type: actionTypes.DATASET_BUDGET_FETCH_BUDGET, payload: rsp.payload }]));

const fetchBudgetEpic = (action$) => action$.ofType(actionTypes.DATASET_BUDGET_FETCH_BUDGET).map((rsp) => fetchBudget(rsp.payload.farmId, rsp.payload.id, true, [{ type: actionTypes.DATASET_BUDGET_COPY_FARM, payload: rsp.payload }]));

const createFarmEpic = (action$, store) => action$.ofType(actionTypes.DATASET_BUDGET_COPY_FARM).map((rsp) => createDatasetFarm(store, rsp.payload));

const createBudgetEpic = (action$, store) => action$.ofType(actionTypes.DATASET_BUDGET_COPY_BUDGET).map((rsp) => createDatasetBudget(store, rsp.payload));

const getDatasetEpic = (action$) => action$.ofType(actionTypes.DATASET_BUDGET_FETCH_DATASET).map((rsp) => getDataset(rsp.payload));

const epics = combineEpics(initBudgetCopyEpic, fetchFarmEpic, fetchBudgetEpic, createFarmEpic, createBudgetEpic, getDatasetEpic);

export default epics;
